import { define } from '../redux-request';

export const SET_LOADING_PROGRESS = define('SET_LOADING_PROGRESS');

export function setLoadingProgress(data) {
  return {
    type: SET_LOADING_PROGRESS,
    payload: data,
  };
}
